import React from 'react';
import { Dropdown, Search } from 'lib/components';
import { MultiselectDropdown } from 'lib/components/dropdown/MultiselectDropdown';
import { Flex } from 'lib/components/styles/layout';
import { LP_DESIGN_CATEGORIES } from '../constants';
import { useIsFetching, useIsMutating } from 'react-query';
import { landingPageDesignsKeys } from 'lib/api/superadmin/landingPageDesigns/landingPageDesignsKeys';
import { IGroupOption, IResellerOption, ITemplateOption } from '../types';

export interface ILandingPageDesignFilterSection {
  templateOptions: ITemplateOption[];
  selectedTemplate: LP_DESIGN_CATEGORIES | null;
  setSelectedTemplate: React.Dispatch<
    React.SetStateAction<LP_DESIGN_CATEGORIES | null>
  >;
  setSelectedResellers: React.Dispatch<
    React.SetStateAction<(string | number)[]>
  >;
  resellerOptions: IResellerOption[];
  groupOptions: IGroupOption[];
  setSelectedGroups: React.Dispatch<React.SetStateAction<(string | number)[]>>;
  onLandingPagesSearchHandler: (value: string) => void;
  searchQuery: string;
  isFetchingResellers: boolean;
  isFetchingGroups: boolean;
  fetchSearchAutocompleteData: (search: string) => Promise<any>;
  isFetchingAutocompleteData: boolean;
}

export const LandingPageDesignFilterSection = ({
  templateOptions,
  selectedTemplate,
  setSelectedTemplate,
  setSelectedResellers,
  resellerOptions,
  onLandingPagesSearchHandler,
  searchQuery,
  isFetchingResellers,
  fetchSearchAutocompleteData,
  isFetchingAutocompleteData,
  isFetchingGroups,
  groupOptions,
  setSelectedGroups,
}: ILandingPageDesignFilterSection) => {
  const isFetchingLandingPageDesigns = !!useIsFetching(
    landingPageDesignsKeys.all()
  );
  const isDuplicating =
    useIsMutating({
      mutationKey: landingPageDesignsKeys.duplicate(),
    }) > 0;

  return (
    <Flex
      justifyContent='space-between'
      gap='14px'
      flexDirection='row'
      width='100%'
      flex={1}
    >
      <Dropdown
        placeholder={'All templates'}
        isSearchable={false}
        value={templateOptions.find(
          option => option.value === selectedTemplate
        )}
        onChange={template => {
          setSelectedTemplate(template.value);
        }}
        options={templateOptions}
        width={200}
        disabled={
          isFetchingResellers ||
          isFetchingLandingPageDesigns ||
          isDuplicating ||
          isFetchingGroups
        }
        creatable={false}
        className='dropdown'
      />

      <MultiselectDropdown
        onOptionsSelected={setSelectedGroups}
        options={groupOptions}
        menuListValue={-1}
        menuListLabel='All Groups'
        isClearable
        isSearchable
        name='group'
        menuShouldBlockScroll={false}
        isLoading={isFetchingGroups}
        selectInputWidth='200px'
        menuWidth='250px'
        isDisabled={isFetchingLandingPageDesigns || isDuplicating}
        zIndex={1}
      />
      <MultiselectDropdown
        onOptionsSelected={setSelectedResellers}
        options={resellerOptions}
        menuListValue={-1}
        menuListLabel='All Resellers'
        isClearable
        isSearchable
        name='reseller'
        menuShouldBlockScroll={false}
        isLoading={isFetchingResellers}
        selectInputWidth='200px'
        menuWidth='250px'
        isDisabled={isFetchingLandingPageDesigns || isDuplicating}
        zIndex={1}
      />
      <Search
        onSearch={onLandingPagesSearchHandler}
        prevSearch={searchQuery}
        placeholder='Search by template, reseller, customer…'
        disabled={isFetchingLandingPageDesigns || isDuplicating}
        onAutocomplete={fetchSearchAutocompleteData}
        isFetchingAutocompleteData={isFetchingAutocompleteData}
      />
    </Flex>
  );
};
